export const textEng=[
"Search for parliament member",
"Order"
]